import { F, Mail, Sec, Info } from "@/components/legal/LegalUi";

export const MENTIONS_TOC = [["editeur", "Éditeur"], ["hebergement", "Hébergement"], ["pi", "Propriété intellectuelle"], ["responsabilite", "Responsabilité"], ["contact", "Contact"]];

export const Mentions = () => (
  <>
    <Sec id="editeur" title="Éditeur du site">
      <p>Le service Wanderlust est exploité par <F k="operator" />, dans le cadre du studio Amagui AI. Le présent site internet Wanderlust est édité par :</p>
      <Info rows={[
        ["Raison sociale / exploitant", <F k="operator" />],
        ["Forme juridique", <F k="legalForm" />],
        ["Capital social", <F k="capital" />],
        ["Siège social", <F k="address" />],
        ["SIREN / SIRET", <F k="siren" />],
        ["TVA intracommunautaire", <F k="vat" />],
        ["Directeur de la publication", <F k="publicationDirector" />],
        ["Contact", <Mail />],
      ]} />
    </Sec>
    <Sec id="hebergement" title="Hébergement">
      <p>Le site est hébergé par :</p>
      <Info rows={[["Hébergeur", "Emergent"], ["Site", <F k="hostUrl" />], ["Adresse", <F k="hostAddress" />]]} />
    </Sec>
    <Sec id="pi" title="Propriété intellectuelle">
      <p>Wanderlust est une application proposée dans le cadre du studio Amagui AI.</p>
      <p>L'ensemble des contenus présents sur le site Wanderlust, incluant notamment les textes, éléments visuels, logos, graphismes, interfaces, éléments de marque et contenus générés, est protégé par les lois en vigueur relatives à la propriété intellectuelle.</p>
      <p>Sauf autorisation écrite préalable, toute reproduction, représentation, adaptation, diffusion ou exploitation, partielle ou totale, des éléments du site est interdite.</p>
    </Sec>
    <Sec id="responsabilite" title="Responsabilité">
      <p>L'éditeur s'efforce de fournir sur le site des informations aussi précises que possible. Toutefois, il ne pourra être tenu responsable des omissions, inexactitudes ou carences dans la mise à jour.</p>
      <p>Les informations, suggestions d'escapades, estimations de budget, durées, temps de trajet et recommandations sont fournies à titre indicatif. L'utilisateur reste seul responsable de ses choix, réservations, déplacements et vérifications finales.</p>
    </Sec>
    <Sec id="contact" title="Contact">
      <p>Pour toute question, vous pouvez écrire à : <Mail /></p>
    </Sec>
  </>
);
